import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import moment from "moment"
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils"

export const invoiceList = createAsyncThunk("invoice/list", async ({ pageable: data, navigate }) => {
    try {
        const res = await axios({
            method: "GET",
            url: getConfig.API_URL + `invoice_management`,
            params: {
                pageSize: data?.pageSize,
                pageNo: data?.currentPage,
                search: data?.search,
                premise_id: data?.premise_id,
                unit_id: data?.unit_id,
                invoice_status: data?.invoice_status,
                from_date: data?.date_from && moment(data?.date_from, "DD/MM/YYYY").format("YYYY-MM-DD"),
                to_date: data?.date_to && moment(data?.date_to, "DD/MM/YYYY").format("YYYY-MM-DD"),
            },
            headers: { "Content-Type": "application/json", Authorization: SessionManager.getCookie("user_token") },
        })
        return res
    } catch (error) {
        return error.response
    }
})

const invoice = createSlice({
    name: "invoice",
    initialState: {
        list: [],
        loading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(invoiceList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.list = action.payload.data.data
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate)
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.list = []
            }
        })
    },
})

export default invoice.reducer;